// extracted by mini-css-extract-plugin
export default {"error":"_zAtvNV9j3Iozbz0s55J"};